import {
  RegisterOptions,
  useController,
  Control,
  FieldValues,
  Path,
} from "react-hook-form";
import DigitInput from "../components/DigitInput";

interface DigitInputContainerProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  rules?: Omit<
    RegisterOptions<TFieldValues>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  length: number;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
}

const DigitInputContainer = <TFieldValues extends FieldValues = FieldValues>(
  props: DigitInputContainerProps<TFieldValues>,
) => {
  const { field, fieldState } = useController<TFieldValues>({
    control: props.control,
    name: props.name,
    rules: props.rules,
  });

  return (
    <DigitInput
      value={field.value}
      onChange={field.onChange}
      name={field.name}
      errorMessage={fieldState.error?.message || props.errorMessage}
      hasError={!!fieldState.error || props.hasError}
      length={props.length}
      disabled={props.disabled}
    />
  );
};

export default DigitInputContainer;
